import React from "react";
import { TagTableProps, TagTableState } from "./models";


import { Box, IconButton, Stack } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';

import MaterialReactTable from 'material-react-table';
import type { MRT_ColumnDef } from 'material-react-table';

import EditIcon from "@mui/icons-material/Edit";

import { t } from "@lingui/macro";
import { Tag } from "models";
import { ConfirmModal } from "commons/modal/confirm-modal";


export class TagTable extends React.Component<TagTableProps, TagTableState>
{
    private tableColumns: MRT_ColumnDef[];

    public constructor(props: any) {

        super(props)

        this.state={
            openConfirmModal: false,
            tagToDelete: ""
        }

        this.tableColumns = [
            {
                header: t({
                    id: "tt-table-col-title",
                    message: "Nome Tag"
                }),
                accessorKey: "value",
                Cell: ({ cell }) => {
                    return (
                        <Box>
                            {cell.getValue<string>()}
                        </Box>
                    );
                },
            },
        ];
    }

    private openConfirmModal = (id: string) : void =>{
        this.setState(() => ({
            openConfirmModal: true,
            tagToDelete: id
        }))
    }

    private cancelConfirmModalCallback = () : void =>{
        this.setState(() => ({
            openConfirmModal: false,
            tagToDelete: ""
        }))
    }

    private acceptConfirmModal = () : void =>{
        this.setState(() => ({
            openConfirmModal: false,
        }))
        this.deleteTag()
    }

    private deleteTag = (): void => {
        this.props.deleteTag(this.state.tagToDelete);
        this.setState(() => ({
            tagToDelete: ""
        }))

    }

    private getIdValue = (row: any): string => {
        return row.original.id
    }

    private openEditModal = (tag: any) => {
        this.props.openEditTagTable(tag as Tag);
    }

    private handlePageChange = (updateFn: any) => {
        let newPagination = updateFn(this.props.pagination);
        this.props.updatePaginationCallBackFn(newPagination);
    }  

    render() {
        return (
            <>
            <Box style={{ maxWidth: '100%' }}>
                <MaterialReactTable
                    columns={this.tableColumns}
                    rowCount={this.props.totalTagCount}
                    pageCount={Math.ceil(this.props.totalTagCount / this.props.pagination.pageSize)}
                    data={this.props.tags}
                    enableRowSelection={false}
                    enableColumnOrdering={false}
                    enableColumnActions={false}
                    enableGlobalFilter={false}
                    enableFilters={false}
                    muiTableHeadCellProps={{
                        sx: {
                            color: "white",
                            backgroundColor: process.env.REACT_APP_PRIMARY_COLOR
                        }
                    }}
                    displayColumnDefOptions={{
                        'mrt-row-actions': {
                            header: ""
                        }
                    }}
                    enableRowActions
                    positionActionsColumn="last"
                    renderRowActions={({ row }) => (
                        <Stack direction={"row"} display={"flex"} justifyContent={"right"} >
                            <IconButton onClick={() => this.openEditModal(row.original)}>
                                <EditIcon />
                            </IconButton>
                            <IconButton onClick={() => this.openConfirmModal(this.getIdValue(row))}>
                                <DeleteIcon />
                            </IconButton>
                        </Stack>
                    )}
                    onPaginationChange={this.handlePageChange}
                    enableTopToolbar={false}
                    manualPagination={true}
                    autoResetPageIndex={false}
                    enableDensityToggle={false}
                    state={{
                        pagination: this.props.pagination
                    }} />
            </Box>
                {this.state.openConfirmModal && <ConfirmModal
                    cancelConfirmCallback={this.cancelConfirmModalCallback}
                    confirmCallback={this.acceptConfirmModal}
                    text={"Sei sicuro di voler procedere con l'eliminazione del tag?"}
                    textId={"tt-delete-tag-text"}
                />}
            </>)
    }
}
